import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import Layout from '../../components/Layout';
import SidebarLayout from '../../components/SidebarLayout';


const Interviews = () => {
  useEffect(() => {
    navigate('wells-fargo', { replace: true});
  }, []);

  return null;
};

const InterviewWithLayout = () => (
  <Layout>
    <SidebarLayout>
      <Interviews />

    </SidebarLayout>
  </Layout>
);

export default InterviewWithLayout;
